import { SET_WATCHER_EXISTS } from '../action-types';
import { WatcherExistsType } from '../reducers/watcherExists.types';

export const setWatcherExists = (watcherExistsData: WatcherExistsType) =>
  <const>{
    type: SET_WATCHER_EXISTS,
    payload: { ...watcherExistsData },
  };

export type WatcherExistsActions = ReturnType<typeof setWatcherExists>;
